export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  FOLDERS: '/folders',
  // Projects live at the leaf of their folder path, so one splat serves the folder listing
  // and the project page alike; @lib/routing/projectPath tells them apart and builds them.
  FOLDER: '/folders/*',
  VIEWER_FOLDER: '/viewer/folders/*',
  PROJECTS: '/projects',
  // Kept so links minted before projects moved under the folder tree still resolve; both
  // redirect to the path-bearing URL.
  LEGACY_PROJECT: '/projects/:projectId/*',
  LEGACY_VIEWER_PROJECT: '/viewer/projects/:projectId/*',
  USERS: '/users',
  TEAMS: '/teams',
  TEAM_DETAIL: '/teams/:teamId',
  SETTINGS: '/settings',
  SERVER_CONFIG: '/server-config',
  NOT_FOUND: '*'
} as const;

export type RoutePaths = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS];
